import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { ConsorsNotesRequestTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
    position?: number;
    subscriptionIdentifier: string;
};

export const schemaLoanRequestResolver_GetConsorsNotesRequestStatus = ConsorsNotesRequestTableDefinitionZod.nullable();

export type SchemaLoanRequestResolver_GetConsorsNotesRequestStatus = z.infer<
    typeof schemaLoanRequestResolver_GetConsorsNotesRequestStatus
>;

export type LoanRequestResolver_GetConsorsNotesRequestStatus = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetConsorsNotesRequestStatus
>;
